import ConsulteeUserSettings from "@publicPortal/pages/consulteeUserSettings/ConsulteeUserSettings";
import getUserCustomProperty from "@shared/mirage/utils/getUserCustomProperty";
import { UserService } from "@publicPortal/services/UserService";
import UserSettings from "@publicPortal/pages/userSettings/UserSettings";
import React, { memo } from "react";

const PublicPortalUserSettings = memo(() => {
    const user = UserService.getLoggedInUser();
    const customProperties = getUserCustomProperty.getUserCustomProperties(user);

    if (customProperties && customProperties.consulteeId) {
        return <ConsulteeUserSettings />;
    }
    return <UserSettings />;
});

export default PublicPortalUserSettings;
